<template>
	<div class="page-printer page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">打印机管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>设备管理</el-breadcrumb-item>
							<el-breadcrumb-item>打印机管理</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
					<el-button type="primary" class="btn-bg-p" @click="handlePrinter('add')">添加 <i
							class="el-icon-plus"></i></el-button>
					<el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;"
							@selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="desk_name" align="center" label="所属店铺" min-width="160">
							</el-table-column>
							<el-table-column prop="name" align="center" label="打印机昵称" min-width="120">
							</el-table-column>
							<el-table-column prop="sn" align="center" label="打印机sn编码" min-width="160">
							</el-table-column>
							<el-table-column prop="key" align="center" label="打印机key编码" min-width="160">
							</el-table-column>
							<el-table-column prop="user" align="center" label="账号" min-width="180">
							</el-table-column>
							<el-table-column prop="user_key" align="center" label="账号密钥" min-width="200">
							</el-table-column>
							<el-table-column prop="number" align="center" label="流量卡号码" min-width="120">
							</el-table-column>
							<el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-o" type="primary" size="mini"
										@click="handlePrinter('edit',scope.row)">编辑</el-button>
									<el-button class="option-btn btn-bd-r" type="primary" size="mini"
										@click="deletePrinter(scope.row.id)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog class="dialog-export printer-dialog" :title="dlg_printer.title" :visible.sync="dlg_printer.visible"
			width="534px" @closed="closePrinter" :close-on-click-modal="false">
			<el-form ref="formPrinter" :model="dlg_printer.form" label-width="110px" :rules="dlg_printer.rules"
				@submit.native.prevent>
				<el-form-item prop="desk_number" label="所属店铺：">
					<el-select size="small" v-model="dlg_printer.form.desk_number" placeholder="请选择">
						<el-option v-for="item in dlg_printer.init_data.desk_list" :key="item.number" :label="item.name"
							:value="item.number">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="name" style="margin-top: 15px;" label="打印机名称：" :error="dlg_printer.error.name">
					<el-input size="small" v-model="dlg_printer.form.name" placeholder='请输入打印机昵称' clearable></el-input>
				</el-form-item>
				<el-form-item prop="sn" label="sn编码：" :error="dlg_printer.error.sn">
					<el-input size="small" v-model="dlg_printer.form.sn" placeholder='请输入打印机sn编码' clearable></el-input>
				</el-form-item>
				<el-form-item prop="key" label="key编码：" :error="dlg_printer.error.key">
					<el-input size="small" v-model="dlg_printer.form.key" placeholder='请输入打印机key编码' clearable>
					</el-input>
				</el-form-item>
				<el-form-item prop="user" label="账号：" :error="dlg_printer.error.user">
					<el-input size="small" v-model="dlg_printer.form.user" placeholder='请输入账号' clearable></el-input>
				</el-form-item>
				<el-form-item prop="user_key" label="账号密钥：" :error="dlg_printer.error.user_key">
					<el-input size="small" v-model="dlg_printer.form.user_key" placeholder='请输入账号密钥' clearable>
					</el-input>
				</el-form-item>
				<el-form-item prop="number" label="流量卡号码：">
					<el-input size="small" type="number" v-model="dlg_printer.form.number" placeholder='请输入流量卡号码'
						clearable></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dlg_printer.visible = false">取 消</el-button>
				<el-button type="primary" @click="submitPrinter()" :loading="dlg_printer.btn_loading">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				multipleSelection: [],
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 30,
						total: 130
					}
				},
				dlg_printer: {
					id: '',
					visible: false,
					btn_loading: false,
					api: '',
					title: '',
					form: {
						desk_number: '',
						name: '',
						sn: '',
						key: '',
						user: '',
						user_key: '',
						number: ''
					},
					error: {
						desk_number: '',
						name: '',
						sn: '',
						key: '',
						user: '',
						user_key: ''
					},
					reset_form: {},
					init_data: {
						desk_list: [],
						status_list: []
					},
					rules: {
						desk_number: {
							required: true,
							message: '请选择所属店铺',
							trigger: ['change', 'blur']
						},
						sn: {
							required: true,
							message: '请输入打印机sn编码',
							trigger: ['change', 'blur']
						},
						key: {
							required: true,
							message: '请输入打印机key编码',
							trigger: ['change', 'blur']
						},
						user: {
							required: true,
							message: '请输入账号',
							trigger: ['change', 'blur']
						},
						user_key: {
							required: true,
							message: '请输入账号密钥',
							trigger: ['change', 'blur']
						}
					}
				}
			}
		},
		created() {
			document.title = '打印机管理';
			this.dlg_printer.reset_form = Object.assign({}, this.dlg_printer.form);
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = {};
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				this.$client.get('/adminapi/printer/list', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.dlg_printer.init_data.desk_list = res.desk_name_list;
					_this.table_data.page_info = res.pager;
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.page = val;
				this.getList();
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delmultiple() {
				var _this = this;
				var mullist = this.multipleSelection;
				if (mullist.length == 0) {
					_this.$message("请勾选需要删除的打印机");
					return;
				}
				var idList = [];
				for (var i = 0; i < mullist.length; i++) {
					idList.push(mullist[i].id);
				}
				var params = {
					id: idList.join(",")
				}
				this.$confirm('确定要批量删除？', "", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						iconClass: "icon-delete el-icon-delete",
						customClass: "my-confirm-box",
						center: true,
					})
					.then(() => {
						_this.$client.post('/adminapi/printer/delete', params, function(res, message) {
							_this.getList();
						}, function(res) {

						});
					})
					.catch(() => {});
			},

			handlePrinter(type, data) {
				this.dlg_printer.visible = true;
				if (type == 'add') {
					this.dlg_printer.title = '添加打印机';
					this.dlg_printer.api = '/adminapi/printer/save';
				} else {
					this.dlg_printer.id = data.id;
					this.dlg_printer.title = '编辑打印机';
					if (data) {
						for (var key in this.dlg_printer.form) {
							this.dlg_printer.form[key] = data[key];
						}
					}
					this.dlg_printer.api = '/adminapi/printer/save?id=' + data.id;
				}
			},
			deletePrinter(id) {
				var _this = this;
				this.$confirm('确定要删除？', "", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						iconClass: "icon-delete el-icon-delete",
						customClass: "my-confirm-box",
						center: true,
					})
					.then(() => {
						_this.$client.post('/adminapi/printer/delete', {
							id: id
						}, function(res, message) {
							_this.getList();
						}, function(res) {

						});
					})
					.catch(() => {});
			},
			submitPrinter() {
				var _this = this;
				_this.$refs['formPrinter'].validate((valid) => {
					if (valid) {
						this.dlg_printer.btn_loading = true;
						this.$client.post(this.dlg_printer.api, this.dlg_printer.form, function(res, message) {
							//console.log(res)
							_this.$message(message);
							_this.getList();
							_this.dlg_printer.btn_loading = false;
							_this.dlg_printer.visible = false;
						}, function(message) {
							_this.dlg_printer.btn_loading = false;
							for (var key in message) {
								_this.dlg_printer.error[key] = message[key];
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closePrinter() {
				for (var key in this.dlg_printer.form) {
					this.dlg_printer.form[key] = this.dlg_printer.reset_form[key];
				}
				this.$nextTick(() => {
					this.$refs.formPrinter.clearValidate();
				})
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>
	.page-printer .el-upload--picture-card {
		line-height: 80px;
	}

	.page-printer .el-upload--picture-card,
	.el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}

	.hide-upload .el-upload--picture-card {
		display: none;
	}
</style>
<style scoped>

</style>
